import * as S from "./styles.ts";

const StyledLink = ({ href, ...props }: any) => {
  const isInternal = href.startsWith("/") || href.startsWith("#");

  if (isInternal) {
    return (
      <S.NextLink
        href={href}
        {...props}
      />
    );
  } else {
    return (
      <S.StandardLink
        href={href}
        {...props}
      />
    );
  }
};

export default StyledLink;
